import { Icon } from '@chakra-ui/react'

import { Floor } from '@/components/icons'

export const FloorIcon = () => {
  return <Icon as={Floor} boxSize='24px' className='icon' strokeColor='#000' />
}
